import React from 'react'
import Chip from '@material-ui/core/Chip'
import LocalAtm from '@material-ui/icons/LocalAtm'

const OneOfChip = () => (
    <Chip variant='outlined' icon={<LocalAtm />} label='Particular' />
)

export default OneOfChip
